import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import castArray from 'lodash/castArray';
import IssueNew from '../document-view/IssueNew';
import {
  pushpinExtensionType,
  documentForCreateType,
  sheetObjectType,
  initialFieldValuesType
} from '../../constants/proptype-validation';

const IssueCreatePanelWrapper = ({
  handleSave,
  isSaving,
  onSuccess,
  onCancel,
  pushpinExtension,
  targetUrn,
  document,
  currentSheet,
  initialFieldValues,
  setPushpinExtensionAction,
  setTargetUrnAction,
  configureSheetsAction,
  configureDocumentSuccessAction,
  availableStatuses,
  headerTitle,
  titleFieldLabel,
  titleFieldRequired
}) => {
  useEffect(() => {
    if (pushpinExtension) {
      setPushpinExtensionAction(pushpinExtension);
    }
  }, [pushpinExtension, setPushpinExtensionAction]);
  useEffect(() => {
    if (targetUrn) {
      setTargetUrnAction(targetUrn);
    }
  }, [setTargetUrnAction, targetUrn]);
  useEffect(() => {
    if (document) {
      configureDocumentSuccessAction(document);
    }
  }, [configureDocumentSuccessAction, document]);
  useEffect(() => {
    if (currentSheet) {
      const sheetsConfigObj = {
        sheetList: [],
        currentSheets: castArray(currentSheet)
      };
      configureSheetsAction(sheetsConfigObj);
    } else {
      configureSheetsAction({
        sheetList: [],
        currentSheets: []
      });
    }
  }, [configureSheetsAction, currentSheet]);
  return (
    <IssueNew
      handleSave={handleSave}
      isSaving={isSaving}
      onSuccess={onSuccess}
      onCancel={onCancel}
      initialFieldValues={initialFieldValues}
      availableStatuses={availableStatuses}
      headerTitle={headerTitle}
      titleFieldLabel={titleFieldLabel}
      titleFieldRequired={titleFieldRequired}
    />
  );
};

IssueCreatePanelWrapper.displayName = 'IssueCreatePanelWrapper';

IssueCreatePanelWrapper.propTypes = {
  handleSave: PropTypes.func,
  isSaving: PropTypes.bool,
  onSuccess: PropTypes.func,
  onCancel: PropTypes.func.isRequired,
  pushpinExtension: pushpinExtensionType.isRequired,
  targetUrn: PropTypes.string.isRequired,
  document: documentForCreateType.isRequired,
  currentSheet: sheetObjectType,
  initialFieldValues: initialFieldValuesType,
  availableStatuses: PropTypes.array,
  headerTitle: PropTypes.string,
  titleFieldLabel: PropTypes.string,
  titleFieldRequired: PropTypes.bool,

  // dispatch
  setPushpinExtensionAction: PropTypes.func.isRequired,
  setTargetUrnAction: PropTypes.func.isRequired,
  configureSheetsAction: PropTypes.func.isRequired,
  configureDocumentSuccessAction: PropTypes.func.isRequired
};

export default IssueCreatePanelWrapper;
